<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
    background: #f4f1ff;
    overflow: hidden;
}
#app {
    font-family: "PingFang SC", "Microsoft YaHei", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1f1633;
    width: 100%;
    height: 100%;
}
.page-box {
    margin-top: 16px;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue